module.exports = __webpack_public_path__ + "img/Stratasys-F370.c90b2143.png";